import {IDynamicObject} from '../models/dynamic-object';

export class StringUtils {
  static ReplaceTokens(targetString: string, valuesObj: IDynamicObject) {
    return targetString.replace(/{([^{}]*)}/g, (a: string, b: string) => {
      const r = valuesObj[b.toString()];
      return typeof r === 'string' || typeof r === 'number' ? r.toString() : a;
    });
  }

  static shortenString(targetString: string, maxLength: number): string {
    return targetString.substring(0, maxLength);
  }

  static replaceSpecialCharacterPlusAndSpace(value: string) {
    return value?.replace(/[+\s]/g, '');
  }

  static parseJsonString(value: string) {
    if (value) {
      return JSON.parse(value);
    }
    return null;
  }

  static isEmpty(input: string | null | undefined): boolean {
    return input === undefined || input === null || input === '';
  }
}
